// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"455":"4e2b2829e639ff2f","4896":"06f823b4dc8f43cb"}[chunkId] + ".css";
};